import { Button } from '@grofers/react';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Dropdown } from '../../../UiKit';
import {
  useGetUserData,
  useGetKarmaOptions,
  useGetKarmaUpdateReason,
  useForceUpdateKarma,
} from '../apis';
import { User } from '../../../components/widgets';
import Spinner from 'sushiweb/Spinner/Spinner';
import { grey } from 'sushiweb/tokens/color';
import { Star } from '../../../UiKit/Star/Star';

const UpdateCustomerKarma = () => {
  const [userId, setUserId] = useState(null);
  const [reason, setReason] = useState(null);
  const [expiry, setExpiry] = useState(null);
  const [karmaOptions, setKarmaOptions] = useState({});
  const [karmaScore, setKarmaScore] = useState(null);
  const [reasonOptions, setReasonOptions] = useState({});
  const [expiryOptions, setExpiryOptions] = useState({});
  const [errors, setErrors] = useState({});
  const form = useForm();
  const { register, handleSubmit, reset } = form;
  const { data: karmaOptionsList } = useGetKarmaOptions();

  const {
    isLoading: isUserDataLoading,
    data: userData,
    refetch,
    error,
    isFetching,
  } = useGetUserData(userId);
  const { data: ReasonOptionsList, refetch: refetchResons } =
    useGetKarmaUpdateReason(userId, karmaScore);
  const { mutate: updateUserKarma, isLoading: isMutating } =
    useForceUpdateKarma({
      onSuccess: () => {
        reset();
        setUserId('');
        setReasonOptions({});
        setExpiryOptions({});
        setKarmaScore(null);
      },
    });

  useEffect(() => {
    let options = {};
    karmaOptionsList?.result.forEach((option) => {
      options = {
        ...options,
        [option.score]: (
          <div
            css={`
              diplay: flex;
              gap: 1rem;
              align-items: center;
              width: 100%;
            `}
          >
            <span
              css={`
                border-radius: 50%;
                background-color: ${option?.color?.color};
                width: 14px;
                height: 10px;
              `}
            ></span>
            <div>
              <span className='tw-mr-1'>{option.label}</span>{' '}
              <span>{option.score}</span>
            </div>
          </div>
        ),
      };
    });
    setKarmaOptions(options);
  }, [karmaOptionsList]);

  useEffect(() => {
    let reason_options = {};
    let expiry_options = {};

    ReasonOptionsList?.reason_codes.forEach((option) => {
      reason_options = {
        ...reason_options,
        [option]: option,
      };
    });
    ReasonOptionsList?.expiry_options.forEach((option) => {
      expiry_options = {
        ...expiry_options,
        [option.value]: option.text,
      };
    });

    setReasonOptions(reason_options);
    setExpiryOptions(expiry_options);
  }, [ReasonOptionsList]);

  const getUser = (data) => {
    setUserId(data.user_id);
  };

  const updateKarma = () => {
    if (!karmaScore) {
      setErrors((prevState) => {
        return {
          ...prevState,
          karmaScore: 'Karms Score is required',
        };
      });
      return null;
    }
    if (!reason) {
      setErrors((prevState) => {
        return {
          ...prevState,
          reason: 'Reason is required',
        };
      });
      return null;
    }
    if (!expiry) {
      setErrors((prevState) => {
        return {
          ...prevState,
          expiry: 'Expiry is required',
        };
      });
      return null;
    }
    updateUserKarma({
      user_id: Number(userId),
      karma_score: Number(karmaScore),
      reason_code: reason,
      expiry_days: expiry,
    });
  };

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-5 tw-h-max'>
      <div className='tw-w-full tw-flex tw-gap-5 '>
        <form
          className='tw-flex tw-flex-col tw-flex-1  tw-gap-5 tw-bg-white tw-p-8 tw-rounded-2xl'
          onSubmit={handleSubmit(getUser)}
        >
          <div className='tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500'>
            Customer ID <Star icon='*' />
          </div>
          <div className='tw-w-full tw-flex tw-h-max'>
            <div className='tw-flex tw-flex-col tw-w-4/5'>
              <input
                id='userId'
                name='user_id'
                placeholder='Please enter customer id'
                className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] focus:tw-ring-green-500 focus:tw-border-green-500  tw-border tw-border-solid tw-border-grey-300 tw-mr-6`}
                {...register('user_id')}
                autoComplete='off'
                required
              />
            </div>
            <Button variant={'fill'} className='tw-h-16  tw-w-1/4'>
              {isUserDataLoading ? (
                <Spinner size='medium' color={`${grey.z300}`} />
              ) : (
                'Find Customer'
              )}
            </Button>
          </div>
        </form>
        {userId && userData && userData?.id && (
          <div
            className='tw-flex tw-flex-1 tw-gap-5 tw-bg-white tw-p-8 tw-rounded-2xl'
            data-dd-privacy='mask'
          >
            <User userId={userId} isNewUser />
          </div>
        )}
      </div>
      <form
        className={`tw-w-full tw-gap-10 tw-bg-white tw-p-8 tw-rounded-2xl ${
          userId && userData ? 'tw-flex tw-flex-col tw-flex-1' : 'tw-hidden'
        }`}
        onSubmit={handleSubmit(updateKarma)}
      >
        <div className='tw-flex tw-gap-5'>
          <div className='tw-flex tw-flex-col tw-gap-5 tw-flex-1'>
            <div className='tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500'>
              Karma Score <Star icon='*' />
            </div>
            <div
              css={`
                div {
                  width: 100%;
                }
              `}
            >
              <Dropdown
                dropDownValues={karmaOptions}
                onSelect={(value) => {
                  setKarmaScore(value);
                  setErrors((prevState) => {
                    return {
                      ...prevState,
                      karmaScore: null,
                    };
                  });
                }}
                dropdownVal={karmaScore}
                placeholder='Select Karma'
                maxMenuHeight='19rem'
                error={errors.karmaScore}
                errorText={errors.karmaScore}
              />
            </div>
          </div>
          <div
            className='tw-flex-1'
            style={{
              cursor: `${karmaScore ? 'pointer' : 'not-allowed'}`,
            }}
          >
            <label
              className='tw-flex tw-flex-col tw-gap-5 tw-flex-1'
              style={{
                pointerEvents: `${karmaScore ? 'auto' : 'none'}`,
                cursor: `${karmaScore ? 'pointer' : 'not-allowed'}`,
                width: '100%',
              }}
              css={`
                & div {
                  width: 100%;
                }
              `}
            >
              <div
                className={`tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500 ${
                  !karmaScore ? 'tw-text-grey-400 tw-mb-2' : ''
                }`}
              >
                Reason{karmaScore && <Star icon='*' />}
              </div>
              <Dropdown
                dropDownValues={reasonOptions}
                onSelect={(value) => {
                  setReason(value);
                  setErrors((prevState) => {
                    return {
                      ...prevState,
                      reason: null,
                    };
                  });
                }}
                dropdownVal={reason}
                placeholder='Select Reason'
                maxMenuHeight='19rem'
                error={errors.reason}
                errorText={errors.reason}
              />
            </label>
          </div>
          <div
            className='tw-flex-1'
            style={{
              cursor: `${karmaScore ? 'pointer' : 'not-allowed'}`,
            }}
          >
            <label
              className='tw-flex tw-flex-col tw-gap-5 tw-flex-1'
              style={{
                pointerEvents: `${karmaScore ? 'auto' : 'none'}`,
                cursor: `${karmaScore ? 'pointer' : 'not-allowed'}`,
                width: '100%',
              }}
              css={`
                & div {
                  width: 100%;
                }
              `}
            >
              <div
                className={`tw-w-full tw-color-[#1F1F1F] tw-font-bold tw-text-500 ${
                  !karmaScore ? 'tw-text-grey-400 tw-mb-2' : ''
                }`}
              >
                Expiry{karmaScore && <Star icon='*' />}
              </div>
              <Dropdown
                dropDownValues={expiryOptions}
                onSelect={(value) => {
                  setExpiry(value);
                  setErrors((prevState) => {
                    return {
                      ...prevState,
                      expiry: null,
                    };
                  });
                }}
                dropdownVal={expiry}
                placeholder='Select Expiry'
                maxMenuHeight='19rem'
                error={errors.expiry}
                errorText={errors.expiry}
              />
            </label>
          </div>
        </div>
        <Button variant={'fill'} size='medium' className='tw-h-16 tw-w-56'>
          {isMutating ? (
            <Spinner size='medium' color={`${grey.z300}`} />
          ) : (
            'Submit'
          )}
        </Button>
      </form>
    </div>
  );
};

export default UpdateCustomerKarma;
